import { balanceParrotModel } from '@models/balance.parrot.model';
import { useModel } from 'foca';
import { useEffect } from 'react';
import { useAddress } from './use-address';
import { useRefreshTime } from './use-refresh';

export const useParrotInitBalances = () => {
  const { refreshTime } = useRefreshTime();
  const address = useAddress();
  const balances = useModel(balanceParrotModel, (state) => state.balances[address || '']);

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;
    const loop = () => {
      address && balanceParrotModel.getBalances(address);

      timer = setTimeout(() => {
        loop();
      }, 30_000);
    };
    loop();
    return () => {
      clearTimeout(timer);
    };
  }, [address, refreshTime]);

  return { balances: balances || [] };
};

export const useParrotBalances = () => {
  const address = useAddress();
  const balances = useModel(balanceParrotModel, (state) => state.balances[address || '']);
  return { balances: balances || [] };
};

export const useParrotBalance = (coinType: string | undefined) => {
  const address = useAddress();
  const balances = useModel(balanceParrotModel, (state) => state.balances[address || '']);
  return {
    balance: balances?.find((balance) => balance.coinType === coinType)?.totalBalance || '0',
  };
};
